import { Pixall, Google } from '../analytics/index.js';
import { getBrandUnit } from '../utilities/index.js';
export function sendNotifyMeClick(_ref, option) {
  let {
    dataLayer
  } = _ref;
  const cmp = 'ntf_btn';
  Pixall.sendClickEvent({
    label: cmp
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventResult: 'cta::notify-me'
  }, option);
  return {
    cmp
  };
}
export function sendSubscribeClick(_ref2, option) {
  let {
    data = {},
    dataLayer,
    state
  } = _ref2;
  const {
    brand = ''
  } = state;
  const cmp = 'subscr_nft';
  Pixall.sendClickEvent({
    label: cmp
  }, dataLayer, option);
  Google.sendClickEvent({
    ...data,
    eventAction: 'save',
    eventResult: 'save::search::email-notify',
    eventElement: getBrandUnit(brand)
  }, option);
  return {
    cmp
  };
}
export function sendCaptureSubscribeClick(_ref3, option) {
  let {
    dataLayer,
    data,
    state
  } = _ref3;
  const {
    brand = ''
  } = state;
  const cmp = 'subscr_srch';
  Pixall.sendClickEvent({
    label: cmp
  }, dataLayer, option);
  Google.sendClickEvent({
    ...data,
    eventAction: 'save',
    eventResult: 'save::search::email-subscribe',
    eventElement: getBrandUnit(brand)
  }, option);
  return {
    cmp
  };
}
export function sendSubscribeAlertClick(_ref4, option) {
  let {
    dataLayer
  } = _ref4;
  const cmp = 'cta::alert::subscribe::email';
  Pixall.sendClickEvent({
    eventSource: 'button',
    label: cmp,
    hasListingType: false
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventResult: cmp
  }, option);
  return {
    cmp
  };
}
export default {
  sendNotifyMeClick,
  sendSubscribeClick,
  sendCaptureSubscribeClick,
  sendSubscribeAlertClick
};